module.exports = __webpack_public_path__ + "static/media/litige.21dcc1c1.svg";